import type { SharePointSite } from "./ExcelDataLinking.types";

export const transformSharePointResponse = (values = []) => {
    const rows = (values ?? []).reduce((acc, values: [], index) => {
        acc[index] = {
            cells: values.reduce((acc2, value, index2) => {
                acc2[index2] = { text: value };
                return acc2;
            }, {}),
        };
        return acc;
    }, {});

    return { rows };
};

/**
 * Returns the label for a SharePoint site. Graph's /sites?search=* does not always return displayName,
 * so fall back to the site's name, then to "Untitled".
 */
export const getSiteDisplayName = (site: SharePointSite): string => site.displayName || site.name || "Untitled";
